import { FC } from 'react';
import { useBusinessLayout } from '../../contexts/LayoutContext';
import { BusinessHubMenuItem } from './business-hub-menu-item';
import styles from './business-hub-top-navigation-menu-item.module.scss';

interface Props {
    isMobile?: boolean;
}

export const BusinessHubTopNavigationMenuItem: FC<Props> = (props) => {
    const { businessHubMenuData = [] } = useBusinessLayout();

    return (
        <div className={styles.container}>
            {businessHubMenuData.map(({ key, ...data }) => (
                <BusinessHubMenuItem key={key} {...data} />
            ))}
        </div>
    );
};
